module.exports = __webpack_public_path__ + "static/media/Service_Design.78a170ec.jpg";